import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "last-week-revision-macroeconomics",
  title: "Last-Week Revision Strategy for Macroeconomics II: 7-Day High-Yield Roadmap",
  description:
    "A day-by-day 7-day revision roadmap for DU Macroeconomics II. IS-LM, Mundell-Fleming, Phillips Curve, Solow Growth Model, and past 5-year paper solving.",
  pubDate: "2026-07-05",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "exam-strategy",
  tags: ["macroeconomics", "revision", "exam-prep", "du-exams", "7-day-roadmap"],
  readMinutes: 10,
  heroEyebrow: "Exam Craft · Revision Roadmap",
};

export function Body() {
  return (
    <>
      <p>
        Revising Macroeconomics II in the final 7 days before end-semester examinations set by the{" "}
        <a href="https://exam.du.ac.in/" target="_blank" rel="noopener noreferrer">
          DU Examination Branch
        </a>{" "}
        requires systematic prioritization of core models prescribed on{" "}
        <a href="https://economicsdu.ac.in/" target="_blank" rel="noopener noreferrer">
          economicsdu.ac.in
        </a>
        .
      </p>

      <h2>Day-by-Day High-Yield Revision Schedule</h2>
      <div className="space-y-3 my-6 border border-rule p-5 bg-card text-sm font-mono">
        <div><strong>Day 1:</strong> Closed Economy IS-LM Model, Multipliers &amp; Crowding Out</div>
        <div><strong>Day 2:</strong> Open Economy Mundell-Fleming Model (Fixed vs Floating Exchange Rates)</div>
        <div><strong>Day 3:</strong> Aggregate Supply &amp; Expectations-Augmented Phillips Curve</div>
        <div><strong>Day 4:</strong> Solow Neoclassical Growth Model (Steady State &amp; Golden Rule Capital)</div>
        <div><strong>Day 5:</strong> Inflation Targeting &amp; RBI Monetary Policy Transmission</div>
        <div><strong>Day 6:</strong> Past 5-Year Question Papers (Solving 15-mark questions under timer)</div>
        <div><strong>Day 7:</strong> Formula Sheet &amp; Diagrammatic Blurting Verification</div>
      </div>

      <h2>Related Macro Revision Resources</h2>
      <p>
        Review detailed theoretical derivations in our guides on{" "}
        <a href="/blog/fiscal-vs-monetary-policy" className="font-semibold underline text-grade">
          Fiscal Policy vs Monetary Policy
        </a>{" "}
        and{" "}
        <a href="/blog/gdp-deflator-vs-cpi" className="font-semibold underline text-grade">
          GDP Deflator vs CPI Inflation Analysis
        </a>
        .
      </p>
    </>
  );
}


